import { useContext, createContext } from 'react';

export const TopicContext = createContext(null);

export function useTopicContext() {
  return useContext(TopicContext);
}
